// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__W-cpX","clinicsSelect":"styles_clinicsSelect__1IVYA"};